import { types, actions } from './requests'
export const CREATECUSTOMER_TYPES = {
    ...types('CREATECUSTOMER'),
}
export const CREATECUSTOMER_ACTIONS = {
    ...actions('CREATECUSTOMER'),
}